import api from '../index'
import env from '../../store/base/config/env'

var auth_endpoint = '/auth/Users/authenticate'

if (env.VUE_APP_USE_LDAP === 'true') {
    auth_endpoint = '/Users/adauthenticate'
}

const api_requests = {
    login: async (username, password) => {
        try {
            var payload = {
                userName: username,
                password: password
            }
            var response = await api.post(auth_endpoint, payload)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    logout: async () => {
        try {
            var response = await api.get(`/auth/Users/signout`)
            return response.data
        } catch (error) {
            console.error('Failed Logout: ', error, error.response)
        }
    },
    register: async (firstName, email, password) => {
        try {
            var payload = {
                firstName,
                email,
                password
            }
            var response = await api.post('/auth/Users/register', payload)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response
            } else throw error
        }
    },
    refresh: async (token) => {
        try {
            var payload = {
                token
            }
            var response = await api.post('/auth/Users/refresh', payload)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    create: async (firstName, lastName, email, roles) => {
        try {
            var payload = {
                firstName: firstName,
                lastName: lastName,
                //   "userName": "string",
                email: email,
                roles: roles
            }

            var response = await api.post('/auth/Users', payload)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },

    verify_email: async (token) => {
        try {
            var response = await api.post('/auth/Users/verify_email', { token })
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    lookup: async (token) => {
        try {
            var response = await api.get(`/auth/Users/lookup/${token}`)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    request_password_reset: async (email) => {
        try {
            var payload = {
                email
            }
            var response = await api.post(`/auth/Users/forgot`, payload)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    reset_password: async (token, password) => {
        try {
            var payload = {
                token,
                password
            }
            var response = await api.post(`/auth/Users/activate`, payload)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    fetchUsers: async () => {
        try {
            var response = await api.get('/auth/Users')
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    updateSelf: async (firstName, lastName, email) => {
        try {
            var payload = {
                firstName: firstName,
                lastName: lastName,
                email: email
            }

            var response = await api.put('/auth/User/updateSelf', payload)

            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    verifyTurnstile: async (token) => {
        try {
            var response = await api.post(`/wellful/UserProfile/Turnstile/Verify`, { token: token })
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    }
}

export default api_requests
